import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SchoolServices } from '../services';
import { Globals } from '../../../globals';
import * as moment from 'moment';
import { TeachersListPage } from '../teachers-list/teachers-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-teachers-view.html',
  templateUrl: 'teachers-view.html',
})
export class TeachersViewPage {
  teacher: any;
  classrooms: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public fb: FormBuilder,
    public http: HttpClient,
    public alertCtrl: AlertController,
    public schoolServices: SchoolServices,
    public globals: Globals,
    public translate: TranslateService) {

    this.teacher = this.navParams.get('teacher');
    this.teacher.created_date = moment(this.teacher.created_at.toDate()).format("DD/MM/YYYY HH:MM");
    this.getStundetsTeacher();
  }

  onBack() {
    this.navCtrl.pop();
  }

  async getStundetsTeacher() {

    this.classrooms = await this.schoolServices.getClassroomsWithStudentsOfTeacher(this.globals.school_uid, this.teacher.UID);
  }

  async delete() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-eliminar-profesor'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.deleteTeacher();

          }
        }
      ]
    });
    alert.present();
  }

  async deleteTeacher() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-eliminando-profesor')
    });
    loadingPopup.present();

    //eliminar de classrooms
    await this.schoolServices.deleteTeachersFromClassrooms(this.globals.school_uid, this.teacher.UID);
    //eliminar de users
    await this.schoolServices.deleteTeacherFromUsers(this.teacher.UID);
    //eliminar de teachers
    await this.schoolServices.deleteTeacher(this.teacher.UID);

    loadingPopup.dismiss();
    this.navCtrl.setRoot(TeachersListPage);


  }

}



// WEBPACK FOOTER //
// ./src/pages/schools/teachers-view/teachers-view.ts